__turbopack_context__.v({
  "className": "noedisplaybold_2d59700e-module__UAySsG__className",
  "variable": "noedisplaybold_2d59700e-module__UAySsG__variable",
});
